import React from 'react';
import { IconSvgProps } from '@models/common';

const TextUnderline: React.FC<IconSvgProps> = (props) => {
  const { size = 16, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M4 2.66699V6.66699C4 7.72786 4.42143 8.74527 5.17157 9.49542C5.92172 10.2456 6.93913 10.667 8 10.667C9.06087 10.667 10.0783 10.2456 10.8284 9.49542C11.5786 8.74527 12 7.72786 12 6.66699V2.66699'
        stroke='currentColor'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2.66797 13.333H13.3346'
        stroke='currentColor'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default TextUnderline;
